import moment from "moment";

export const trackerDefaultFields = {
  notes: "",
  date_time: moment().format('YYYY-MM-DDTHH:mm'),
  percentage: 50,
}